import styled, { css } from 'styled-components';

const Backdrop = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: none;
    justify-content: center;
    align-items: center;
    z-index: 5;

    ${(props) => props.isOpen && css`
        display: flex;
    `}
`;

const ModalWrapper = styled.div`
    position: relative;
    width: ${({ isMobile, isTablet }) => 
        isMobile ? '100%' : 
        isTablet ? '85%' : 
        'min(1370px, 85vw)'
    };
    height: fit-content;
    background-color: white;
    font-family: "Inter", sans-serif;
    border-radius: 10px;
    padding: ${({ isMobile, isTablet }) => 
        isMobile ? '0' : 
        isTablet ? '20px' : 
        '24px'
    };
`;

const ModalContainer = styled.div`
    display: grid;
    grid-template-columns: ${({ isMobile }) => 
        isMobile ? '1fr' : 'repeat(2, 1fr)'
    };
    border-radius: 10px;
    height: ${({ isMobile, isTablet }) => 
        isMobile ? 'calc(100vh - 60px)' : 
        isTablet ? 'auto' : 
        'auto'
    };
    gap: ${({ isMobile, isTablet }) => 
        isMobile ? '0' : 
        isTablet ? '20px' : 
        '24px'
    };
    margin-top: ${({ isMobile }) => 
        isMobile ? '24px' : '34px'
    };

    > div:first-child {
        background-color: ${props => props.theme.colors.primaryWhite};
    }

    > div:last-child {
        background-color: ${props => props.theme.colors.highClearGray};
    }

    > div:first-child, > div:last-child {
        padding: ${({ isMobile }) => 
            isMobile ? '12px' : '16px'
        };
    }
`;

const GenericListContainer = styled.ul`
    list-style: none;
    display: flex;
    flex-direction: column;
    padding: 0;
    gap: ${({ isMobile }) => 
        isMobile ? '8px' : '10px'
    };
`;

const ModalDescription = styled.p`
    display: inline-block;
    margin: ${({ isMobile }) => 
        isMobile ? '6px 0 24px 0' : '8px 0 32px 0'
    };
    font-weight: 300;
    font-size: ${props => props.theme.fonts.size.lt1};
`;


const ModalButtonsContainer = styled.div`
    display: flex;
    gap: ${({ isMobile }) => 
        isMobile ? '8px' : '10px'
    };
`;

const ModalHeaderContainer = styled.div`
    display: flex;
    justify-content: space-between;

    flex-direction: ${({ isMobile }) => 
        isMobile ? 'column' : 'row'
    };
    gap: ${({ isMobile }) => 
        isMobile ? '12px' : '0'
    };
`;

const Title = styled.p`
    display: inline-block;
    font-size: ${({ isMobile }) => 
        isMobile ? props => props.theme.fonts.size.base : props => props.theme.fonts.size.s1
    };
    font-weight: 600;
    margin: 0;
`;

export {
    ModalWrapper,
    ModalButtonsContainer,
    Backdrop,
    ModalContainer,
    ModalDescription,
    Title,
    ModalHeaderContainer,
    GenericListContainer
};
